<template>
  <div class="app-exception">
    <div class="app-exception__img app-exception__img--404"></div>
    <h1>404</h1>
    <p>抱歉，你访问的页面不存在</p>
  </div>

</template>
<script>
export default {
  name: 'NotFound'
}
</script>
<style lang="less">
  .app-exception {
    text-align: center;
    padding: 50px 30px;
    &__img {
      width: 300px;
      height: 300px;
      display: inline-block;
      background-size: 300px 300px;
      &--403 {
        background-image: url('../../assets/img/403.png');
      }
      &--404 {
        background-image: url('../../assets/img/404.png');
      }
      &--500 {
        background-image: url('../../assets/img/500.png');
      }
    }
    img {
      display: block;
      width: 100%;
    }
    h1 {
      font-size: 4em;
    }
    button {
      margin-top: 20px;
    }
  }
</style>
